import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_protected/$organizationId/$flowId/settings/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$organizationId/$flowId/settings/provider",
      params: { organizationId: params.organizationId, flowId: params.flowId },
    });
  },
});
